import { PriceRequestFiltersResponseApiDto } from '@lx/shared/api';

export type PriceRequestFilters = PriceRequestFiltersResponseApiDto;
export type PriceRequestFilterAccommodationType = PriceRequestFiltersResponseApiDto.AccommodationsEnum;
export const PriceRequestFilterAccommodationTypes = PriceRequestFiltersResponseApiDto.AccommodationsEnum;
